import React from 'react'
import Footer from '../components/Footer'
import { motion } from 'framer-motion';
import aboutImage from '../images/about.jpg';

const About = () => {
     const fadeInUp = {
    hidden: { opacity: 0, y: -40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  const slideInLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };

  const slideInRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };
  return (
    <div>

<section className="py-5" id="about" aria-labelledby="about-heading">
      <div className="container">
        {/* Section Header */}
        <motion.div
          className="text-center mb-5"
          initial="hidden"
          whileInView="visible"
          variants={fadeInUp}
          viewport={{ once: true, amount: 0.3 }}
        >
          <h2 id="about-heading" className="display-4 fw-bold text-dark mb-3">
            About Us
          </h2>
          <p className="lead text-muted">
           The Majestic Hotel & Banquet, located in Lucknow, Uttar Pradesh,
          </p>
        </motion.div>

        {/* Content Row */}
        <div className="row g-4 align-items-center">
          {/* Image */}
          <motion.div
            className="col-md-6"
            initial="hidden"
            whileInView="visible"
            variants={slideInLeft}
            viewport={{ once: true, amount: 0.2 }}
          >
            <img
              src={aboutImage}
              alt="Healthcare professionals"
              className="img-fluid rounded shadow"
            />
          </motion.div>

          {/* Text Content */}
          <motion.div
            className="col-md-6"
            initial="hidden"
            whileInView="visible"
            variants={slideInRight}
            viewport={{ once: true, amount: 0.2 }}
          >
            <h3 className="h4 fw-semibold text-dark mb-3">Welcome to Majestic Lawn</h3>
            <p className="text-muted mb-4">
             The Majestic Hotel & Banquet, located in Lucknow, Uttar Pradesh, is a premier venue known for hosting a variety of events, including weddings, receptions, engagements, corporate events, and social gatherings like birthday parties and conferences. Below is a synthesized "About Us" content based on the available information from various sources:
            </p>

          
          </motion.div>
        </div>
      </div>
    </section>

        <Footer/>
    </div>
  )
}

export default About